var exports = {
  "b": "RulesetPageHeader__H562hS",
  "$r": "RulesetLabel__pZNSDY",
  "HS": "RulesetContentBox__n1dI6i",
};

module.exports = exports;
